import { ICostCategoryState, IState } from "./_interfaces";

import {
    SET_IKA_MAP_COUNTRIES,
    SET_IKA_MAP_COUNTRIES_LOADING,
    SET_IKA_MAP_DATA,
    SET_IKA_MAP_DATA_LOADING,
    SET_IKA_ERROR,
    SET_INPUT_SUGGESTIONS,
    SET_COST_CATEGORIES_DATA,
    SET_COST_CATEGORIES_DATA_LOADING
} from './constants';

const initialState:IState = {
    countriesLoading: false,
    countries: [],
    loading: false,
    IKAMaps: [],
    error: '',
    inputSuggestions: {
        buyng_group_cust_name: [],
        cust_planning_level: [],
        cust_planning_level_name: [],
        gkc: [],
    },
}

const initialCostCategoryState:ICostCategoryState = {
    loading: false,
    error: '',
    CostCategoriesMapping:[]
}

const IKAMapReducer = (state:IState = initialState, action:any):IState => {
    const { type, payload } = action;

    switch (type) {
        case SET_IKA_MAP_COUNTRIES:
            return {
                ...state,
                countriesLoading: false,
                countries: payload,
            }
        case SET_IKA_MAP_COUNTRIES_LOADING:
            return {
                ...state,
                countriesLoading: payload,
            }
        case SET_IKA_MAP_DATA:
            return {
                ...state,
                loading: false,
                IKAMaps: payload,
            }
        case SET_IKA_MAP_DATA_LOADING:
            return {
                ...state,
                loading: payload,
            }

        case SET_IKA_ERROR:
            return {
                ...state,
                error: payload,
            }
        case SET_INPUT_SUGGESTIONS:
            return {
                ...state,
                inputSuggestions: payload,
            }

    }
    
    return state;
}

const CostCategoryReducer = (state:ICostCategoryState = initialCostCategoryState, action:any):ICostCategoryState => {
    const { type, payload } = action;

    switch (type) {
        case SET_COST_CATEGORIES_DATA_LOADING:
            return {
                ...state,
                loading: payload,
            }
        case SET_COST_CATEGORIES_DATA:
            return {
                ...state,
                loading: false,
                CostCategoriesMapping: payload,
            }
    }
    
    return state;
}

export { IKAMapReducer, CostCategoryReducer };